import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IUserRolesRes } from './index.type';

const useGetUserRoles = ({ excluded }: { excluded?: string[] }) => {
    const [userRolesData, setUserRolesData] = useState<string[] | undefined>([]);

    const excludedQuery =
        excluded && excluded.length > 0
            ? "?exclude=" + excluded.join(",")
            : "";
            
    const url = `/users/roles${excludedQuery && excludedQuery}`;
    const { loading: userRolesDataLoading, makeApiCall } = useApi({
        url,
        method: 'GET',
    });

    const getUserRoles = async () => {
        const { response, error } = await makeApiCall<undefined, IUserRolesRes>();
        if (response?.status === 'success') {
            setUserRolesData(response.data);
        }

        if (response?.status === 'fail') {
            setUserRolesData(undefined);
        }

        if (error) toast.error('Something went wrong while fetching user roles data. Please try again later');
    };

    useEffect(() => {
        getUserRoles();
        // eslint-disable-next-line
    }, []);

    return {
        userRolesData,
        getUserRoles,
        userRolesDataLoading,
    };
};

export default useGetUserRoles;
